<template>
	<div class="innerBox">
		<h2 class="mb-4">Kategori Pricelist</h2>
		<button
			class="btn btn-info float-right mb-4 mr-2"
			@click="showModalAdd = true"
		>
			Tambah Kategori
		</button>

		<table class="table mr-2 text-center" >
			<thead class="thead-dark">
				<th>No.</th>
				<th>No. Kategori</th>
				<th>Minimum Harga</th>
				<th>Maximum Harga</th>
				<th colspan="2"><i class="fa fa-cog"></i></th>
			</thead>
			<tbody v-if="data">
				<tr v-for="(dat, index) in data" :key="index">
					<td>{{index + 1}}</td>
					<!-- <td>{{dat}}</td> -->
					<td>Kategori {{dat.id}} ( {{dat.name}} )</td>
					<td>Rp. {{numberWithCommas(dat.min ? dat.min : 0)}}</td>
					<td>Rp. {{numberWithCommas(dat.max ? dat.max : 9999999999)}}</td>
					<td><button class="btn btn-primary" @click="editModal(dat)"><i class="fa fa-edit"></i></button></td>
					<td><button class="btn btn-danger" @click="deleteData(dat.id)"><i class="fa fa-times-circle"></i></button></td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr>
					<td colspan="6">Loading.....</td>
				</tr>
			</tbody>
		</table>

		<newCategory 
			v-if="showModalAdd"
			:method="'post'"
			:buttonName="'Tambah'"
			@closeModal="showModalAdd = false"
			@updateTable="getData"
		/>

		<newCategory 
			v-if="showModalEdit"
			:method="'put'"
			:buttonName="'Edit'"
			:data="editData"
			@closeModal="showModalEdit = false"
			@updateTable="getData"
		/>
  	</div>
</template>

<script>
import newCategory from './children/newCategory'
export default {
	components : {
		newCategory
	},
	data() {
		return {
			data : null,
			showModalAdd : false,
			showModalEdit : false,
			editData : null
		}
	},
	mounted () {
		this.getData()
	},
	methods : {
		getData () {
			let url = '/api/v1/insurance/car'

			this.$http.get(url)
			.then((resp) => {
				this.data = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		editModal (data) {
			this.showModalEdit = true
			this.editData = data

		},
		deleteData(id) {
			let url = '/api/v1/insurance/car/' + id
			this.$http.delete(url)
			.then((resp) => {
				this.$store.dispatch('triggerAlert' ,  [true , `Kategori Telah Berhasil Dihapus`])
				this.getData()
			})
			.catch((err) => {
				console.log(err)
			})
		}
	}
}
</script>